const variants = {
  warning: {
    background: "#FFB23719",
    borderColor: "warning",
  },
  danger: {
    background: "#c2ae4319",
    borderColor: "failure",
  },
  success: {
    background: "rgba(49, 208, 170, 0.1)",
    borderColor: "success",
  },
  primary: {
    background: "rgba(118, 69, 217, 0.1)",
    borderColor: "secondary",
  },
};

export default variants;
